import { AiChatState } from "@intelligems/ig-types/schemas/ai/ai-chat-state";
import { aiApiClient } from "@src/api/ai-api";
import { aiSitewideAnalyticsKeys } from "@src/api/queryKeys";
import { useQuery } from "@tanstack/react-query";

interface UseGetSitewideAnalyticsChatSessionHistoryOptions {
  sessionId: string | null | undefined;
  orgId: string;
  enabled?: boolean;
}

const getSitewideAnalyticsChatSessionHistory = async (
  sessionId: string
): Promise<AiChatState | null> => {
  const response = await aiApiClient.get<AiChatState | null>(
    `/chat-history/session/${sessionId}`
  );
  return response.data ?? null;
};

export const useGetSitewideAnalyticsChatSessionHistory = ({
  sessionId,
  orgId,
  enabled = true,
}: UseGetSitewideAnalyticsChatSessionHistoryOptions) => {
  return useQuery<AiChatState | null, Error>({
    queryKey: aiSitewideAnalyticsKeys.chatSessionHistory(orgId, sessionId!),
    queryFn: async () => getSitewideAnalyticsChatSessionHistory(sessionId!),
    enabled: enabled && !!sessionId,
  });
};
